import type {ConvertToRulesetPreview} from '../types'

export type PreviewsCountSummaryProps = {
  previews: ConvertToRulesetPreview[]
}

export function PreviewsCountSummary({previews}: PreviewsCountSummaryProps) {
  const branchProtectionCount = previews?.length ?? 0
  const rulesetCount = previews?.reduce((acc, {rulesets}) => acc + rulesets.length, 0) ?? 0

  const pluralizedBranchProtectionCount = branchProtectionCount === 1 ? 'rule' : 'rules'
  const pluralizedRulesetCount = rulesetCount === 1 ? 'ruleset' : 'rulesets'

  return (
    <span>
      {rulesetCount} {pluralizedRulesetCount}{' '}
      <span>
        will be created from {branchProtectionCount} branch protection rule {pluralizedBranchProtectionCount}.
      </span>
    </span>
  )
}
